<template>
  <div>
    <div class="app-main__inner">
      <TituloComponente
        icono-titulo="fas fa-plus"
        texto-titulo="Nuevo Regimen"
      />
      <div class="tab-content">
        <div
          class="tab-pane tabs-animation fade show active"
          id="tab-content-0"
          role="tabpanel"
        >
          <div class="row">
            <div class="col-lg-12">
              <div class="main-card mb-3 card">
                <div class="card-body">
                  <h5 class="card-title">Datos:</h5>
                  <form @submit.prevent="guardarRegimenJubilatorio()">
                    <float-label label="Código:" clase>
                      <input
                        v-model="regimenJubilatorio.codigo"
                        id="codigo"
                        placeholder="Ingresar un código..."
                        type="text"
                        class="form-control"
                        :class="
                          enviado && !$v.regimenJubilatorio.codigo.required
                            ? 'is-invalid'
                            : ''
                        "
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.regimenJubilatorio.codigo.required"
                        >
                          Debe ingresar un código
                        </div>
                      </template>
                    </float-label>
                    <float-label label="Descripción:" clase="">
                      <input
                        id="descripcion"
                        v-model="regimenJubilatorio.descripcion"
                        placeholder="Ingresar una descripción..."
                        type="text"
                        class="form-control"
                      />
                    </float-label>
                    <button class="mt-1 btn btn-info float-right">
                      Guardar
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponente from "@/components/layouts/TituloComponente";
import { required } from 'vuelidate/lib/validators';
import FloatLabel from "@/components/layouts/FloatLabel";
import RegimenJubilatorio from "@/models/regimenJubilatorio";
import axios from "axios";
export default {
  name: "NuevoSindicato",
  components: {
    TituloComponente,
    FloatLabel,
  },
  data() {
    return {
      regimenJubilatorio: new RegimenJubilatorio(null, "", ""),
    };
  },
  validations:{
    regimenJubilatorio:{
      codigo:{required},
      descripcion:{required},
    }
  },
  methods: {
    guardarRegimenJubilatorio() {
      axios
        .post("/regimenjubilatorio", this.regimenJubilatorio)
        .then((res) => {
          if (res.data.success) {
            this.$router.push({ name: "ListarRegimenJubilatorio" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
      console.log(this.regimenJubilatorio);
    },
  },
};
</script>